/** Run async work over items in parallel chunks (order within a chunk is unordered). */
export async function mapInChunks<T>(
  items: readonly T[],
  chunkSize: number,
  fn: (item: T, index: number) => Promise<void>,
): Promise<void> {
  const size = Math.max(1, chunkSize);
  for (let i = 0; i < items.length; i += size) {
    const chunk = items.slice(i, i + size);
    await Promise.all(chunk.map((item, offset) => fn(item, i + offset)));
  }
}

export const GANTT_SAVE_PARALLEL_CHUNK_SIZE = 8;
